import * as React from "react";
import theme from "styles/theme";
import { formatMessage } from "lib/globalize-util";
import { List, ListItem } from "material-ui/List";
import Avatar from "material-ui/Avatar";
import CircularProgress from "material-ui/CircularProgress";
import { $, merge } from "glamor";
import { DATATEST } from "constants/integration";
import Popover from "material-ui/Popover";

interface IProps {
    searchTerm: string;
    onAdd: any;
    onFetchContacts: any;
    users: any;
    userEntities: any;
    onChangeSearchTerm: any;
    inputRef: React.ReactInstance;
}

export class SearchDropdown extends React.PureComponent<IProps, any> {
    static PAGE_SIZE = 5;

    private muiStyles = {
        brandUserEntry: {
            color: theme.palette.primary1Color,
        },
        buyerListItem: {
            borderBottom: `1px solid ${theme.palette.borderColor}`,
            padding: "6px 0",
        },
        flexItem: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        },
        loading: {
            padding: "24px 0",
            textAlign: "center" as "center",
            maxHeight: "300px",
            width: "356px",
        },
        smallFlexItem: {
            fontSize: "14px",
        },
        noResults: {
            maxHeight: "300px",
            width: "356px",
        },
        resultList: {
            maxHeight: "300px",
        },
        anchorOrigin: {
            horizontal: "left",
            vertical: "bottom",
        },
        targetOrigin: {
            horizontal: "left",
            vertical: "top",
        },
        innerDivStyle: {
            textAlign: "center" as "center",
        },
    };

    private styles = merge(
        $(" .noResults", {
            display: "block",
            height: "64px",
            lineHeight: "56px",
            padding: "8px 0 0",
            position: "relative",
            textAlign: "center",
        }),
        $(" .flexWrapper", {
            display: "flex",
            flexWrap: "wrap",
        }),
        $(" .flexItem", {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        }),
        $(" .brandUserTitle", {
            color: theme.palette.primary1Color,
            fontSize: "14px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        }),
        $(" .smallFlexItem", {
            fontSize: "14px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        })
    );

    handleAddItem = (attr) => {
        this.props.onAdd(attr);
    };

    getInitials = (user) => {
        let initals = "";
        if (user.name) {
            const chunks = user.name.split(" ");
            for (let i = 0; i < chunks.length; i++) {
                if (i >= 2) {
                    break;
                }
                initals = initals + (chunks[i][0] || "");
            }
        }

        return initals.toUpperCase();
    };

    handleRequestClose = () => {
        this.props.onChangeSearchTerm();
    };

    render() {
        const { searchTerm, users, userEntities, inputRef } = this.props;
        const isLoadingContacts = users.isFetching;
        let recipientOptions = [];
        if (users.result.length) {
            recipientOptions = users.result.map((id) => {
                return userEntities[id];
            });
        }

        const isOpen = searchTerm && searchTerm !== "" ? true : false;
        let results = null;
        if (isLoadingContacts) {
            results = (
                <div style={this.muiStyles.loading}>
                    <CircularProgress />
                </div>
            );
        } else if (recipientOptions.length > 0) {
            const items = [];
            const hasMore = recipientOptions.length === SearchDropdown.PAGE_SIZE * 2 + 1;
            recipientOptions.forEach((user) => {
                const primaryText = (
                    <div className="flexWrapper">
                        <div className="flexItem">{user.get("name")}</div>
                    </div>
                );

                const secondaryText = (
                    <div className="flexWrapper">
                        <div className="smallFlexItem">{user.get("email")}</div>
                    </div>
                );
                items.push(
                    <ListItem
                        data-test={DATATEST.ASSORTMENTS.SHARE_SEARCH_RESULT}
                        key={user.get("_id")}
                        primaryText={primaryText}
                        secondaryText={secondaryText}
                        secondaryTextLines={2}
                        leftAvatar={<Avatar>{user.initials}</Avatar>}
                        style={this.muiStyles.buyerListItem}
                        onClick={this.handleAddItem.bind(this, user)}
                    />
                );
            });

            if (hasMore) {
                items.push(
                    <ListItem
                        key="more"
                        primaryText={formatMessage("Please refine your search to view more results.")}
                        innerDivStyle={this.muiStyles.innerDivStyle}
                        disabled={true}
                    />
                );
            }

            results = <List style={this.muiStyles.resultList}>{items}</List>;
        } else {
            results = (
                <List style={this.muiStyles.noResults}>
                    <ListItem
                        key="noResults"
                        primaryText={formatMessage("No results found.")}
                        innerDivStyle={this.muiStyles.innerDivStyle}
                        disabled={true}
                        data-test={DATATEST.ASSORTMENTS.SHARE_NO_RESULTS}
                    />
                </List>
            );
        }

        return (
            <Popover
                open={isOpen}
                anchorEl={inputRef}
                anchorOrigin={this.muiStyles.anchorOrigin as any}
                targetOrigin={this.muiStyles.targetOrigin as any}
                data-test={DATATEST.ASSORTMENTS.SHARE_SEARCH_DROPDOWN}
                onRequestClose={this.handleRequestClose}
            >
                {results}
            </Popover>
        );
    }
}

export default SearchDropdown;
